<template>
  <div>
    <div v-if="updateExists" class="w-full flex items-center justify-between md:justify-center px-4 md:px-0 py-3 bg-blue-lighter transition">
      <span class="mr-4">Update beschikbaar</span>
      <button @click="refreshApp()" class="bg-blue-dark text-white uppercase py-2 px-4 text-xs font-semibold tracking-wide rounded">
        updaten
      </button>
    </div>
    <header class="bg-white sm:flex sm:items-center sm:justify-between xl:bg-white">
      <div class="flex justify-between px-4 py-3 xl:w-72 xl:bg-white xl:justify-center xl:py-5 xl:border-r">
        <div class="text-green-dark">
          <router-link :to="{ name: 'home' }" class="font-semibold text-xl">
            Van Santen Advies
          </router-link>
        </div>
        <div class="flex sm:hidden">
          <button @click="menuIsOpen = !menuIsOpen" type="button" class="px-2 text-grey-dark hover:text-grey-darker focus:outline-none focus:text-grey-daker">
            <svg class="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path v-if="menuIsOpen" fill-rule="evenodd" clip-rule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"/>
              <path v-if="!menuIsOpen" fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/>
            </svg>
          </button>
        </div>
      </div>
      <nav class="sm:flex sm:items-center sm:px-4 xl:flex-1 xl:justify-between xl:px-8" :class="{ 'hidden': !menuIsOpen, 'block': menuIsOpen }">
        <div class="hidden xl:block xl:relative xl:max-w-xs xl:w-full">
          <navbar-search></navbar-search>
        </div>
        <navbar-routes></navbar-routes>
      </nav>
    </header>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import NavbarSearch from '@/components/header/NavbarSearch';
import NavbarRoutes from '@/components/header/NavbarRoutes';
import FilterLayout from '@/components/filters/FilterLayout';

export default {
  name: 'TheHeader',
  template: '#header-container',
  components: {
    FontAwesomeIcon,
    NavbarSearch,
    NavbarRoutes,
    FilterLayout
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
      filtersIsOpen: false,
      menuIsOpen: false
    };
  },
  created() {
    // Listen for swUpdated event and display refresh message as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });

    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload(true);
    });
  },
  methods: {
    showRefreshUI(e) {
      // Display a button inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;

      this.updateExists = true;
    },
    refreshApp() {
      // Handle a user tap on the update app button.
      this.updateExists = false;

      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) return;

      this.registration.waiting.postMessage('skipWaiting');
    }
  },
  watch: {
    $route() {
      this.menuIsOpen = false;
    }
  }
};
</script>
